import { Box, CardBody, CardFooter, CardHeader, FormControl, FormErrorMessage, FormLabel, Input, Skeleton, VStack } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { SubmitBtn } from "../../atoms/button/SubmitBtn";
import { useFetchIfreaAnalyticsSetting } from "../../../hooks/ifreaAnalytics/useFetchIfreaAnalyticsSetting";
import { useEditIfreaAnalyticsSettingForm } from "../../../hooks/ifreaAnalytics/useEditIfreaAnalyticsSettingForm";
import { useEditIfreaAnalyticsSetting } from "../../../hooks/ifreaAnalytics/useEditIfreaAnalyticsSetting";
import { DarkShadowCard } from "../../molecules/card/DarkShadowCard";
import { CardHeading } from "../../molecules/card/CardHeading";
import { SettingsIcon } from "@chakra-ui/icons";


export const EditIfreaAnalyticsSetting = () => {
  const { settingsId } = useParams();
  const { setting, isLoading } = useFetchIfreaAnalyticsSetting(settingsId);
  const { handleSubmit, register, isSubmitting, errors } = useEditIfreaAnalyticsSettingForm(setting)
  const onSubmit = useEditIfreaAnalyticsSetting(settingsId)
  const ifreaAnalyticsRestaurantIdError = errors.ifrea_analytics_restaurant_id?.message;
  return (
    <Box m='auto' w={{base: '100%', md: '600px'}}>
      <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
        <DarkShadowCard>
          <CardHeader>
            <CardHeading icon={<SettingsIcon />} heading='ifreaアナリティクス設定'/>
          </CardHeader>
          <CardBody py={2}>
            <VStack spacing={5}>
              <FormControl isRequired isInvalid={!!errors.ifrea_analytics_restaurant_id} w='100%'>
                <FormLabel>ifreaアナリティクス店舗ID</FormLabel>
                <Skeleton isLoaded={!isLoading} w='100%' borderRadius={5}>
                  <Input type="text" {...register('ifrea_analytics_restaurant_id')} />
                </Skeleton>
                <FormErrorMessage>{ifreaAnalyticsRestaurantIdError}</FormErrorMessage>
              </FormControl>
            </VStack>
          </CardBody>
          <CardFooter>
            <SubmitBtn isLoading={isSubmitting}>登録</SubmitBtn>
          </CardFooter>
        </DarkShadowCard>
      </form>
    </Box>
  );
};